import { CarInsurancePremiumedProduct } from 'car-insurance/types';

export const getPremiumValue = (
  product: CarInsurancePremiumedProduct,
): number => {
  if (product.premium) {
    return product.premium.duePremium;
  }
  const attribute = product.attributeList.find(
    (attribute) => attribute.attributeType === 'CLICK_OUT_PREMIUM',
  );
  return attribute ? Number(attribute.value) : Infinity;
};
